import { Component, type ErrorInfo, type ReactNode } from "react";

type AppErrorBoundaryProps = {
  children: ReactNode;
};

type AppErrorBoundaryState = {
  hasError: boolean;
};

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[TycoonexErrorBoundary]", error, info.componentStack);
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="grid min-h-dvh place-items-center bg-(--ty-bg) px-6 py-12 text-ink">
        <div className="max-w-md text-center">
          <h1 className="font-display text-lg font-semibold">Something went wrong</h1>
          <p className="mt-2 text-sm text-ink-mute">
            TycoonEX hit an unexpected error. Reload to try again.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            className="ty-cta mt-6 rounded-full px-6 py-3 font-mono text-xs font-medium uppercase tracking-[0.12em]"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
